


// import React, { useState, useEffect } from 'react';
// import { ClipboardList, Award, Users, FileCheck } from 'lucide-react';

// export default function WhyChooseUsInfographic() {
//   const [isVisible, setIsVisible] = useState(false);
//   const [hoveredStep, setHoveredStep] = useState(null);
  
//   useEffect(() => {
//     setIsVisible(true);
//   }, []);

//   // Primary color for consistency
//   const primaryColor = "#3182CE"; // Blue
//   const accentColor = "#E2E8F0"; // Light gray

//   // Data for the steps with new information
//   const steps = [
//     {
//       step: "STEP A",
//       title: "SAP Expertise",
//       description: "Deep understanding of SAP project life cycles",
//       icon: <ClipboardList size={24} />,
//       position: "top"
//     },
//     {
//       step: "STEP B",
//       title: "Proven Track Record",
//       description: "Proven track record across industries and geographies",
//       icon: <Award size={24} />,
//       position: "bottom"
//     },
//     {
//       step: "STEP C",
//       title: "Dedicated Support",
//       description: "Dedicated account managers and single point of contact",
//       icon: "",
//       position: "top"
//     },
//     {
//       step: "STEP D",
//       title: "Team Integration",
//       description: "Seamless integration with your in-house teams",
//       icon: <Users size={24} />,
//       position: "bottom"
//     },
//     {
//       step: "STEP E",
//       title: "Transparent Delivery",
//       description: "Transparent processes and SLA-driven delivery",
//       icon: <FileCheck size={24} />,
//       position: "top"
//     }
//   ];

//   return (
//     <div className="w-full px-4 py-16 bg-gray-50">
//       <div className="max-w-6xl mx-auto">
//         {/* Title */}
//         <div className="text-center mb-16">
//           <h2 className={`text-3xl md:text-4xl font-bold text-gray-800 mb-4 transition-all duration-1000 ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
//             Why Choose Us?
//           </h2>
//           <div className={`w-24 h-1 bg-blue-500 mx-auto transition-all duration-1000 delay-300 ${isVisible ? 'w-24 opacity-100' : 'w-0 opacity-0'}`}></div>
//         </div>

//         {/* Steps container */}
//         <div className="relative flex flex-col md:flex-row items-center justify-between flex-wrap">
//           {/* Connecting line */}
//           <div className="hidden md:block absolute left-0 right-0 h-1 top-1/2 transform -translate-y-1/2 bg-gray-200 z-0"></div>
          
//           {/* Steps */}
//           {steps.map((step, index) => (
//             <div
//               key={index}
//               className={`relative z-10 w-full md:w-1/5 mb-16 md:mb-0 md:px-3 transition-all duration-700 transform ${
//                 isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
//               }`}
//               style={{
//                 transitionDelay: `${index * 150}ms`,
//               }}
//               onMouseEnter={() => setHoveredStep(index)}
//               onMouseLeave={() => setHoveredStep(null)}
//             >
//               {/* Card */}
//               <div
//                 className={`bg-white rounded-lg shadow-md transition-all duration-300 ${
//                   hoveredStep === index ? 'transform scale-105 shadow-lg' : ''
//                 }`}
//                 style={{
//                   borderRadius: "0.75rem",
//                   overflow: "hidden"
//                 }}
//               >
//                 {/* Icon circle - positioned according to step position */}
//                 <div
//                   className={`absolute ${
//                     step.position === "top" ? "-top-6" : "-bottom-6"
//                   } left-1/2 transform -translate-x-1/2 w-12 h-12 rounded-full flex items-center justify-center bg-white shadow-md transition-all duration-500 ${
//                     hoveredStep === index ? 'scale-110' : ''
//                   }`}
//                   style={{
//                     border: `2px solid ${primaryColor}`,
//                     zIndex: 20
//                   }}
//                 >
//                   <div className="text-blue-600">
//                     {step.icon}
//                   </div>
//                 </div>

//                 {/* Content */}
//                 <div
//                   className="p-5 pt-8 pb-8 text-center"
//                   style={{
//                     backgroundColor: "white",
//                     borderTopLeftRadius: step.position === "top" ? "0" : "0.75rem",
//                     borderTopRightRadius: step.position === "top" ? "0" : "0.75rem",
//                     borderBottomLeftRadius: step.position === "bottom" ? "0" : "0.75rem",
//                     borderBottomRightRadius: step.position === "bottom" ? "0" : "0.75rem",
//                   }}
//                 >
//                   <h3 className="text-lg font-semibold text-gray-800 mb-2">{step.title}</h3>
//                   <p className="text-sm text-gray-600">{step.description}</p>
//                 </div>

//                 {/* Subtle accent */}
//                 <div
//                   className={`h-1 w-full ${
//                     step.position === "bottom" ? "mt-auto" : ""
//                   }`}
//                   style={{ backgroundColor: primaryColor }}
//                 ></div>
//               </div>
//             </div>
//           ))}
//         </div>

//         {/* CTA Button */}
//         <div className={`text-center mt-20 transition-all duration-1000 delay-1000 ${
//           isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
//         }`}>
//           <button
//             className="px-8 py-3 rounded-full font-medium text-white bg-blue-600 transform transition-all duration-300 hover:scale-105 hover:shadow-lg hover:bg-blue-700"
//           >
//             Contact Us Today
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }


// import React, { useState, useEffect } from 'react';
// import { ClipboardList, Award, Users, FileCheck, Headset } from 'lucide-react';

// const  SAPWhyChooseUs=()=> {
//   const [isVisible, setIsVisible] = useState(false);
//   const [hoveredStep, setHoveredStep] = useState(null);
  
//   useEffect(() => {
//     setIsVisible(true);
//   }, []);

//   // Color palette
//   const colors = {
//     primary: '#2B6CB0',            // Deep Blue
//     accent: '#F7FAFC',             // Light Gray
//     stepBg: '#FFFFFF',             // White
//     border: '#CBD5E0',             // Gray Border
//     icon: {
//       expertise: '#3182CE',         // Blue
//       track: '#D69E2E',             // Gold
//       support: '#805AD5',           // Purple
//       integration: '#2F855A',       // Green
//       delivery: '#E53E3E'           // Red
//     }
//   };

//   const steps = [
//     {
//       label: 'STEP A',
//       title: 'SAP Expertise',
//       description: 'Deep understanding of SAP project life cycles',
//       icon: <ClipboardList size={28} style={{ color: colors.icon.expertise }} />,      position: 'top'
//     },
//     {
//       label: 'STEP B',
//       title: 'Proven Track Record',
//       description: 'Proven success across industries and geographies',
//       icon: <Award size={28} style={{ color: colors.icon.track }} />,             position: 'bottom'
//     },
//     {
//       label: 'STEP C',
//       title: 'Dedicated Support',
//       description: 'Account managers & single point of contact',
//       icon: <Headset size={28} style={{ color: colors.icon.support }} />,           position: 'top'
//     },
//     {
//       label: 'STEP D',
//       title: 'Team Integration',
//       description: 'Seamless integration with your in-house teams',
//       icon: <Users size={28} style={{ color: colors.icon.integration }} />,          position: 'bottom'
//     },
//     {
//       label: 'STEP E',
//       title: 'Transparent Delivery',
//       description: 'SLA-driven transparent processes',
//       icon: <FileCheck size={28} style={{ color: colors.icon.delivery }} />,         position: 'top'
//     }
//   ];

//   return (
//     <section className="w-full px-6 py-20 bg-gray-50">
//       <div className="max-w-6xl mx-auto text-center">
//         <h2
//           className="text-4xl font-bold mb-4 transition-opacity duration-1000"
//           style={{ color: colors.primary, opacity: isVisible ? 1 : 0 }}
//         >
//           Why Choose Us?
//         </h2>
//         <div
//           className="mx-auto mb-12 transition-all duration-1000"
//           style={{
//             width: isVisible ? '100px' : '0',
//             height: '4px',
//             backgroundColor: colors.primary,
//             opacity: isVisible ? 1 : 0
//           }}
//         />

//         <div className="relative flex flex-col md:flex-row items-center justify-between">
//           <div className="hidden md:block absolute inset-x-0 top-1/2 h-1 bg-gray-200 transform -translate-y-1/2 z-0" />
//           {steps.map((step, idx) => (
//             <div
//               key={idx}
//               className="relative z-10 w-full md:w-1/5 mb-16 md:mb-0 px-3 transition-all duration-700"
//               style={{
//                 transform: isVisible ? 'translateY(0)' : 'translateY(20px)',
//                 opacity: isVisible ? 1 : 0,
//                 transitionDelay: `${idx * 150}ms`
//               }}
//               onMouseEnter={() => setHoveredStep(idx)}
//               onMouseLeave={() => setHoveredStep(null)}
//             >
//               <div
//                 className={`rounded-lg shadow-md transition-transform duration-300 ${hoveredStep === idx ? 'scale-105 shadow-xl' : ''}`}
//                 style={{
//                   backgroundColor: colors.stepBg,
//                   border: `1px solid ${colors.border}`
//                 }}
//               >
//                 <div
//                   className={`absolute ${step.position === 'top' ? '-top-8' : '-bottom-8'} left-1/2 transform -translate-x-1/2 p-3 rounded-full transition-transform duration-300 ${hoveredStep === idx ? 'scale-110' : ''}`}
//                   style={{
//                     backgroundColor: colors.stepBg,
//                     border: `3px solid ${colors.primary}`
//                   }}
//                 >
//                   {step.icon}
//                 </div>
//                 <div className="p-6 pt-12 text-center">
//                   <h3 className="text-lg font-semibold mb-2" style={{ color: colors.primary }}>{step.title}</h3>
//                   <p className="text-sm text-gray-600">{step.description}</p>
//                 </div>
//                 <div style={{ height: '4px', backgroundColor: colors.primary }} />
//               </div>
//             </div>
//           ))}
//         </div>

//         <button
//           className="mt-20 px-8 py-3 rounded-full font-medium transition-transform duration-300"
//           style={{
//             backgroundColor: colors.primary,
//             color: '#FFFFFF'
//           }}
//           onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.05)'}
//           onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
//         >
//           Contact Us Today
//         </button>
//       </div>
//     </section>
//   );
// }

// export default SAPWhyChooseUs;




import React, { useState, useEffect } from 'react';
import { Network, Briefcase, Clock, Building, FileCheck } from 'lucide-react';

const SAPWhyChooseUs = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [hoveredStep, setHoveredStep] = useState(null);
  
  useEffect(() => {
    setIsVisible(true);
  }, []);

  // Enhanced color palette
  const colors = {
    primary: '#2B6CB0',            // Deep Blue
    secondary: '#3182CE',          // Lighter Blue
    accent: '#F7FAFC',             // Light Gray
    stepBg: '#FFFFFF',             // White
    border: '#E2E8F0',             // Lighter Gray Border
    icon: {
      network: '#3182CE',          // Blue
      flexible: '#D69E2E',         // Gold
      turnaround: '#805AD5',       // Purple
      experience: '#2F855A',       // Green
      delivery: '#E53E3E'          // Red
    }
  };

  const features = [
    {
      title: 'Extensive Consultant Network',
      description: 'Access to a wide network of pre-screened, certified SAP consultants',
      icon: <Network size={32} style={{ color: colors.icon.network }} />,
      position: 'top'
    },
    {
      title: 'Flexible Engagement Models',
      description: 'Contract, contract-to-hire, full-time, offshore/on-site options',
      icon: <Briefcase size={32} style={{ color: colors.icon.flexible }} />,
      position: 'bottom'
    },
    {
      title: 'Quick Turnaround',
      description: 'Rapid resource onboarding and project implementation',
      icon: <Clock size={32} style={{ color: colors.icon.turnaround }} />,
      position: 'top'
    },
    {
      title: 'Cross-Industry Experience',
      description: 'Proven success in manufacturing, retail, healthcare, BFSI, and more',
      icon: <Building size={32} style={{ color: colors.icon.experience }} />,
      position: 'bottom'
    },
    {
      title: 'SLA-Driven Delivery',
      description: 'Dedicated account management with transparent processes',
      icon: <FileCheck size={32} style={{ color: colors.icon.delivery }} />,
      position: 'top'
    }
  ];

  return (
    <section className="w-full px-6 py-10 bg-gradient-to-b from-blue-50 to-gray-50">
      <div className="max-w-6xl mx-auto text-center">
        <h2
          className="text-5xl font-bold mb-2 transition-opacity duration-1000"
          style={{ color: colors.primary, opacity: isVisible ? 1 : 0 }}
        >
          Why Choose Us?
        </h2>
        
        <p 
          className="text-xl text-center text-gray-600 max-w-3xl mx-auto mb-2 transition-opacity duration-1000 delay-300"
          style={{ opacity: isVisible ? 1 : 0 }}
        >
          Your trusted partner for SAP implementation and consulting services
        </p>
        
        <div
          className="mx-auto mb-16 transition-all duration-1000"
          style={{
            width: isVisible ? '120px' : '0',
            height: '4px',
            background: `linear-gradient(to right, ${colors.secondary}, ${colors.primary})`,
            opacity: isVisible ? 1 : 0,
            borderRadius: '2px'
          }}
        />

        <div className="relative flex flex-col md:flex-row items-center justify-between">
          {/* Connecting line */}
          <div className="hidden md:block absolute inset-x-0 top-1/2 h-1 bg-blue-100 transform -translate-y-1/2 z-0" />
          
          {features.map((feature, idx) => (
            <div
              key={idx}
              className="relative z-10 w-full md:w-1/5 mb-16 md:mb-0 px-3 transition-all duration-700"
              style={{
                transform: isVisible ? 'translateY(0)' : 'translateY(20px)',
                opacity: isVisible ? 1 : 0,
                transitionDelay: `${idx * 150}ms`
              }}
              onMouseEnter={() => setHoveredStep(idx)}
              onMouseLeave={() => setHoveredStep(null)}
            >
              <div
                className={`rounded-xl shadow-lg transition-all duration-300 h-full ${
                  hoveredStep === idx ? 'scale-105 shadow-xl' : ''
                }`}
                style={{
                  backgroundColor: colors.stepBg,
                  border: `1px solid ${colors.border}`,
                  transform: hoveredStep === idx ? 'translateY(-8px)' : 'translateY(0)'
                }}
              >
                <div
                  className={`absolute ${
                    feature.position === 'top' ? '-top-10' : '-bottom-10'
                  } left-1/2 transform -translate-x-1/2 p-4 rounded-full transition-transform duration-300 ${
                    hoveredStep === idx ? 'scale-110' : ''
                  }`}
                  style={{
                    backgroundColor: colors.stepBg,
                    border: `3px solid ${Object.values(colors.icon)[idx]}`,
                    boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
                  }}
                >
                  {feature.icon}
                </div>
                <div className="p-6 pt-12 text-center h-full flex flex-col">
                  <h3 className="text-xl font-bold mb-3" style={{ color: Object.values(colors.icon)[idx] }}>
                    {feature.title}
                  </h3>
                  <p className="text-gray-600 flex-grow">
                    {feature.description}
                  </p>
                </div>
                <div 
                  className="rounded-b-xl" 
                  style={{ 
                    height: '5px', 
                    background: `linear-gradient(to right, ${colors.primary}, ${Object.values(colors.icon)[idx]})` 
                  }} 
                />
              </div>
            </div>
          ))}
        </div>

        <button
          className="mt-24 px-10 py-4 rounded-full font-medium text-lg transition-all duration-300"
          style={{
            background: `linear-gradient(to right, ${colors.primary}, ${colors.secondary})`,
            color: '#FFFFFF',
            boxShadow: '0 4px 14px rgba(43, 108, 176, 0.25)'
          }}
          onMouseEnter={e => {
            e.currentTarget.style.transform = 'scale(1.05)';
            e.currentTarget.style.boxShadow = '0 6px 20px rgba(43, 108, 176, 0.3)';
          }}
          onMouseLeave={e => {
            e.currentTarget.style.transform = 'scale(1)';
            e.currentTarget.style.boxShadow = '0 4px 14px rgba(43, 108, 176, 0.25)';
          }}
        >
          Partner With Us Today
        </button>
      </div>
    </section>
  );
}

export default SAPWhyChooseUs;
